import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { MouseEvent, ReactElement, useState } from 'react';

import { ReactComponent as DangerIcon } from '~/ui/assets/images/danger.svg';

import variables from '~/ui/assets/styles/colors.module.scss';
import styles from './ErrorTooltip.module.scss';

interface IProps {
  items: string[];
  color?: string;
}

const ErrorTooltip = ({ items, color }: IProps): ReactElement => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? 'popover' : undefined;

  return (
    <>
      <IconButton aria-describedby={id} onClick={handleClick} className={styles.icon} size="large">
        <DangerIcon color={color ?? variables.colorRed} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={event => event.stopPropagation()}
        onFocus={event => event.stopPropagation()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        classes={{ paper: styles.tooltip }}
      >
        <Box className={styles.column}>
          {items?.map(item => (
            <span key={item}>{item}</span>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default ErrorTooltip;
